<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    full: {
      type: Boolean,
      required: false,
      default: false,
    },
    alter: {
      type: Boolean,
      required: false,
      default: false,
    },
    seccondary: {
      type: Boolean,
      required: false,
      default: false,
    },
    backgroundColor: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('widgets', ['userType']),
    isUserRT() {
      return this.userType === 'storekeepers'
    },
  },
}
</script>
<template>
  <button
    :class="[
      { [$style.buttonRT]: isUserRT },
      { [$style.buttonFull]: full },
      { [$style.buttonAlter]: alter },
      { [$style.buttonSeccondary]: seccondary },
      { [$style.buttonDisabled]: disabled},
      $style.button,
    ]"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<style lang="scss" module>
  @import '@design';
</style>
